import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, SHIPPING_PRICES } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ShippingPriceList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'id', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'deliveryCompany',
				accessor: 'shippingContractName',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'originCountry',
				accessor: 'originCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				show: false
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string
			},
			{
				Header: 'destinationCountry',
				accessor: 'destinationCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				show: false
			},
			{
				Header: 'destinationCity',
				accessor: 'destinationCity',
				filterType: FilterType.string
			},
			{
				Header: 'originTier',
				accessor: 'originTier',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRICE_CONFIGURATION_TIER_TYPE
			},
			{
				Header: 'destinationTier',
				accessor: 'destinationTier',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRICE_CONFIGURATION_TIER_TYPE
			},
			{
				Header: 'isSameCity',
				accessor: 'isSameCityAsString',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'isBetweenCity',
				accessor: 'isBetweenCityAsString',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'greaterThanKm',
				accessor: 'greaterThanKm',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'lessThanOrEqualKm',
				accessor: 'lessThanOrEqualKm',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'greaterThanWeight',
				accessor: 'greaterThanWeight',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'lessThanOrEqualWeight',
				accessor: 'lessThanOrEqualWeight',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'maxFreeWeight',
				accessor: 'maxFreeWeight',
				filterType: FilterType.float
			},
			{
				Header: 'extraWeightPerKg',
				accessor: 'extraWeightPerKg',
				filterType: FilterType.float,
				width: 100
			},
			{
				Header: 'maxFreeKm',
				accessor: 'maxFreeKm',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'extraChargePerKm',
				accessor: 'extraChargePerKm',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'applyCodRateAfter',
				accessor: 'applyCodRateAfter',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'codPercentage',
				accessor: 'codPercentage',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'codCharge',
				accessor: 'codCharge',
				filterType: FilterType.float
			},
			{
				Header: 'returnOrderFee',
				accessor: 'returnOrderFee',
				filterType: FilterType.float
			},
			{
				Header: 'deliveryPrice',
				accessor: 'basePrice',
				filterType: FilterType.float
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.SHIPPING_PRICES}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={SHIPPING_PRICES.GET_SHIPPING_PRICE_SPECIAL_SETTINGS_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="shippingPrices"
			/>
		</TabTableContainer>
	);
};
export default ShippingPriceList;
